<div class="row detail-content__row">
  <div class="col-12 col-lg-2">
    <h5 class="detail-steps__title">Lingue parlate</h5>
  </div>
  <div class="col-12 col-lg-10">
    <div class="e-icons-wrap">
      <div class="e-icons-wrap__icon" *ngFor="let language of languages">
        <div class="e-icons-wrap__icon-svg" [ngStyle]="{'background-image': 'url(' + (language.icon |cdnify) + ')'}"></div>
        <span>{{language.name}}</span>
      </div>
    </div>
  </div>
</div>
